/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Order Request Form

*/

$(function () {

        function initRMAForm() {


            /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

            rma terms toggling

            */
            $(window).scrollTop(0, 0);
            $(window).trigger('initFormValidation');

            let $rma_terms_accepted = $('#id_rma_terms_accepted');
            let $rma_form__main = $('.rma-form__main');

            $rma_terms_accepted.change(function (e) {
                let checkbox = this;
                if (checkbox.checked) {
                    $rma_form__main.show();
                } else {
                    $rma_form__main.hide();
                }

            });

            /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

            new form was added
            TODO: could use, but is not triggered somehow
            */

            $('#rma_attachement_formset').on('formAdded', function (event) {
                newForm = event.target;
                $(window).trigger('initFormModifications');
            });

            $('.file-upload__add-btn').on('click', function (event) {
                // initialize custom-file upload
                $(window).trigger('initFormModifications');
                $(window).trigger('initFormValidation');
                $('[data-toggle="popover"]').popover();
            });

            /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

            set Complaints number

            */
            // $('.rma-form__attachements__header').find('span').content(1);

            $('[data-toggle="popover"]').popover();

        }

        function initRMALanguageNavigation() {
            const $RMAContainer = $('.rma-form-plugin');
            const $RMALanguagesContainer = $('.rma-form-plugin__languages');
            const $RMALanguagesTabs = $RMALanguagesContainer.find('.custom-nav-tabs__item');
            const $RMALanguagesLinks = $RMALanguagesContainer.find('.custom-nav-tabs__link');
            const $RMALanguageToggleItems = $RMAContainer.find('[data-language]');
            let $activeLanguage = $RMALanguagesContainer.find('.custom-nav-tabs__item.active .custom-nav-tabs__link').attr('href');

            $RMALanguagesLinks.on('click', function(event) {
               event.preventDefault();
               const language = $(this).attr('href');
               toggleItems(language);
            });

            function toggleItems(language) {
                const $activeRMALanguageToggleItems = $RMAContainer.find(`[data-language="${language}"]`);
                const $activeRMALanguagesTab = $RMALanguagesContainer.find(`.custom-nav-tabs__link[href="${language}"]`).parent();
                $RMALanguagesTabs.removeClass('active');
                $RMALanguageToggleItems.removeClass('active');
                $activeRMALanguageToggleItems.addClass('active');
                $activeRMALanguagesTab.addClass('active');
            }

            // init with first language
            toggleItems($activeLanguage);
        }

        // on page load
        initRMAForm();
        initRMALanguageNavigation();

        // custom events
        $(window).on('initRMAForm ajaxForm:success', function () {
            initRMAForm();
            initRMALanguageNavigation();
        });
    }
);


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

File Upload

*/

// $('.file-upload__inline-form__form_set').formset({
//     prefix: 'attachement',
//     deleteText: window.orderFormsetTranslations.deleteText,
//     addText: window.orderFormsetTranslations.addText,
//     deleteCssClass: 'btn btn-sm btn-info file-upload__delete-btn',
//     addCssClass: 'btn btn-sm btn-grey file-upload__add-btn',
// });


// $('.file-upload__inline-form__form_set').formset({
//     prefix: 'attachement',
//     deleteText: window.orderFormsetTranslations.deleteText,
//     addButton: $('.file-upload__add-btn'),
// });

//     $('.file-upload__inline-form__form_set').formset({
//         prefix: 'file',
//         deleteText: window.orderFormsetTranslations.deleteText,
//         addText: window.orderFormsetTranslations.addText,
//         deleteCssClass: 'file-upload__delete-btn multi-file-upload__link-remove',
//         addCssClass: 'file-upload__add-btn multi-file-upload__link-add-file btn btn-sm btn-primary-inverted',
//         removed: function ($row) {
//             // remove row
//             $row.remove();
//             // remove dom node of files to prevent it being sent to django form (display: none; doesn't help here obviously)
//             if ($('.multi-file-upload__row').length === 0) {
//                 // init
//                 let $container = $('.multi-file-upload');
//                 // if all files have been delete set TOTAL_FORMS to zero (for backend validation)
//                 $('#id_files-TOTAL_FORMS').val(0);
//                 // mark as no file selected
//                 $container.removeClass('multi-file-upload--file-selected');
//                 // trigger click to reproduce initial state
//                 $container.find('.multi-file-upload__link-add-file').trigger('click');
//                 // "no file selected" indicator
//                 $container.addClass('multi-file-upload--no-file-selected');
//             } else {
//                 // init
//                 let $container = $('.multi-file-upload');
//                 $container.removeClass('multi-file-upload--no-file-selected');
//             }
//         },
//         added: function ($row) {
//             // clean class from cloning
//             $row.removeClass('multi-file-upload__row--file-selected');
//             // clean containe classes
//             if ($('.multi-file-upload__row').length >= 1) {
//                 // mark as no file selected
//                 $('.multi-file-upload').removeClass('multi-file-upload--no-file-selected');
//             }
//             $(window).trigger('initFormModifications');
//         }
//     });
//
//     $(window).on('custom-file-upload:file-selected', function (e, $container) {
//         let $multi_file_upload_row = $container.parents('.multi-file-upload__row');
//         $multi_file_upload_row.addClass('multi-file-upload__row--file-selected');
//         let $multi_file_upload_container = $container.parents('.multi-file-upload');
//         $multi_file_upload_container.addClass('multi-file-upload--file-selected');
//         $multi_file_upload_container.removeClass('multi-file-upload--no-file-selected');
//     });
//
// }



// WEBPACK FOOTER //
// ./static/js/modules/rma-form.js